module.exports = __webpack_public_path__ + "img/ld-img-27@2x.0962706b.png";